import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/guard/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'pages',
    pathMatch: 'full'
  },
  {
    path: 'intro',
    loadChildren: () => import('./intro/intro.module').then(m => m.IntroPageModule)
  },
  {
    path: 'auth',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        loadChildren: () => import('./auth/login/login.module').then(m => m.LoginPageModule)
      },
      {
        path: 'register',
        loadChildren: () => import('./auth/register/register.module').then(m => m.RegisterPageModule)
      },
      {
        path: 'forgot',
        loadChildren: () => import('./auth/forgot/forgot.module').then(m => m.ForgotPageModule)
      },
    ]
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'assessment-summary',
    loadChildren: () => import('./modal/assessment-summary/assessment-summary.module').then(m => m.AssessmentSummaryPageModule)
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./error/maintenance/maintenance.module').then(m => m.MaintenancePageModule)
  },
  {
    path: '**',
    redirectTo: 'error/not-found'
  },
  {
    path: 'error/not-found',
    loadChildren: () => import('./error/not-found/not-found.module').then(m => m.NotFoundPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
